import { matchPath } from "react-router";

type AuthReturnIntent = {
  redirectTo: string;
};

type LocationParts = {
  pathname: string;
  search: string;
  hash: string;
};

export function createAuthReturnIntent(params: { location: LocationParts }): AuthReturnIntent {
  const { location } = params;
  return {
    redirectTo: `${location.pathname}${location.search}${location.hash}`,
  };
}

export function resolveAuthReturnDestination(params: {
  intent: Partial<AuthReturnIntent>;
  origin: string;
  signInPath: string;
  defaultDestination: string;
}): string {
  const { intent, origin, signInPath, defaultDestination } = params;
  const { redirectTo } = intent;

  if (!redirectTo?.startsWith("/") || redirectTo.startsWith("//")) {
    return defaultDestination;
  }

  try {
    const destination = new URL(redirectTo, origin);
    const isSignInDestination = matchPath({ path: signInPath, end: true }, destination.pathname) !== null;
    if (destination.origin !== origin || isSignInDestination) {
      return defaultDestination;
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return defaultDestination;
  }
}
